module.exports = __webpack_public_path__ + "assets/RetinaNarr-BoldItalic.492a50c668cb0a704a0ae09a3e6a0c3f.woff";